import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import { ApiContext } from 'utils/networking/Api.context';

export default function CarouselUrlHook({ hotel, paperlessCarouselUrl }) {
  const { API } = useContext(ApiContext);
  const { appActions } = useContext(AppContext);
  const { translate, getSelectedHotel } = appActions;

  const [state, setState] = useState({
    previewOpen: false,
    previewImage: '',
    fileList: [],
    hotel: null,
  });

  useEffect(() => {
    updateState({ hotel: hotel });
  }, []);

  const actions = {
    copyToHotels: params => {
      const { hotels, appearanceData } = params;
      if (!hotels || hotels.length === 0) return;
      updateState({ isLoading: true });

      Promise.all(
        hotels.map(hotel => {
          if (hotel.hotelId !== state.hotel.id) {
            API.setCarouselUrl(hotel.hotelId, appearanceData)
              .then(res => {
                notification.success({
                  message: translate('appearence.urlSaveSuccess'),
                });
              })
              .catch(error => {
                notification.error({
                  message: translate('appearence.urlError'),
                });
              });
          }
        })
      );

      updateState({ isLoading: false });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
